import React from 'react';
import { motion } from 'framer-motion';
import './css/PageHero.css';

const PageHero = ({ title, imagePath }) => {
  return (
    <section 
      className="page-hero"
      style={{
        backgroundImage: imagePath ? `url("${imagePath}")` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="page-hero-overlay"></div>
      <div className="container page-hero-container">
        <motion.div
          className="page-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <h1 className="page-hero-title">{title}</h1>
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
